var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1024,
    height: 260,
    viewBox: "0 0 1024 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo-light"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 260
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-light",
    clipPath: "url(#clip-logo-light)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_final",
    transform: "translate(-33.57 -722.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3159",
    "data-name": "Grupo 3159",
    transform: "translate(332.138 785.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2422",
    "data-name": "Caminho 2422",
    d: "M366.432,1259.839c-6.771,8-18.465,12.722-31.391,12.722-15.8,0-34.471-10.671-34.471-32.832,0-23.184,18.669-31.6,34.471-31.6,13.13,0,24.824,4.1,31.391,12.1v-13.751c0-10.055-8.619-16.622-21.749-16.622-10.671,0-20.522,3.9-28.932,11.7l-9.851-17.442c12.1-10.671,27.7-15.594,43.294-15.594,22.552,0,43.294,9.026,43.294,37.546v64.02H366.432Zm0-25.852c-4.307-5.748-12.519-8.619-20.929-8.619-10.258,0-18.674,5.336-18.674,14.978,0,9.235,8.416,14.571,18.674,14.571,8.41,0,16.622-2.877,20.929-8.619Z",
    transform: "translate(-300.57 -1139.78)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2423",
    "data-name": "Caminho 2423",
    d: "M540.746,1168.54c20.313,0,32.623,8.8,39.191,17.849L562.885,1202.4c-4.719-6.975-11.9-10.671-20.929-10.671-15.8,0-26.881,11.49-26.881,28.729s11.083,28.927,26.881,28.927a25.022,25.022,0,0,0,20.962-10.665l17.051,15.8c-6.568,9.235-18.878,18.058-39.191,18.058-30.572,0-52.529-21.545-52.529-52.117C488.217,1190.085,510.175,1168.54,540.746,1168.54Z",
    transform: "translate(-385.018 -1139.789)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2424",
    "data-name": "Caminho 2424",
    d: "M712.218,1177.34c16.221,0,25.8,6.447,33.415,16.023l-7.035,6.254c-7.035-9.351-15.434-13.091-25.792-13.091-22.079,0-35.566,17.6-35.566,40.252s13.487,40.45,35.566,40.45c10.357,0,18.757-3.911,25.792-13.289l7.035,6.271c-7.618,9.769-17.194,16.215-33.415,16.215-27.744,0-45.918-22.079-45.918-49.631S684.473,1177.34,712.218,1177.34Z",
    transform: "translate(-465.132 -1143.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2425",
    "data-name": "Caminho 2425",
    d: "M837.53,1180.021h10.159v16.221c8.014-10.555,18.762-18.151,31.853-18.151v11.138a40.813,40.813,0,0,0-5.082-.391c-9.576,0-22.469,8.6-26.771,16.8V1274.4H837.53Z",
    transform: "translate(-542.178 -1144.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2426",
    "data-name": "Caminho 2426",
    d: "M971.5,1177.34c28.723,0,44.554,22.86,44.554,50.054v2.75H937.1c.979,20.517,14.659,37.519,36.737,37.519a41.938,41.938,0,0,0,31.072-13.1l5.275,6.645c-9.384,9.774-21.3,15.242-36.936,15.242-27.552,0-47.3-20.517-47.3-49.63C925.977,1199.419,945.312,1177.34,971.5,1177.34ZM937.1,1222.086H1005.7c-.2-16.023-10.748-35.951-34.394-35.951C949.024,1186.135,937.886,1205.673,937.1,1222.086Z",
    transform: "translate(-581.963 -1143.749)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2427",
    "data-name": "Caminho 2427",
    d: "M1195.337,1231.543a40.2,40.2,0,0,1-32.827,17.387c-25.01,0-42.21-19.147-42.21-49.438,0-29.895,17.2-49.631,42.21-49.631,13.289,0,25.209,6.837,32.827,17.6V1116.27h10.357v130.36h-10.357Zm0-55.3c-5.5-9.186-17.783-17.194-31.066-17.194-20.9,0-33,17.6-33,40.445s12.1,40.258,33,40.258c13.283,0,25.594-7.816,31.066-16.809Z",
    transform: "translate(-669.412 -1116.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2428",
    "data-name": "Caminho 2428",
    d: "M1313.92,1131.866a7.97,7.97,0,0,1,7.816-7.816,7.816,7.816,0,1,1,0,15.632A7.965,7.965,0,0,1,1313.92,1131.866Zm2.75,23.839h10.165v94.382H1316.67Z",
    transform: "translate(-756.532 -1119.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2429",
    "data-name": "Caminho 2429",
    d: "M1371.472,1236.71v-67.023H1355.84V1160.5h15.632V1134.71h10.357V1160.5h19.147v9.186h-19.147v65.455c0,7.618,3.124,12.9,9.769,12.9a14.747,14.747,0,0,0,10.55-4.494l3.911,7.816c-3.713,3.515-8.207,5.858-16.023,5.858C1377.528,1257.227,1371.472,1249.609,1371.472,1236.71Z",
    transform: "translate(-775.394 -1124.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2430",
    "data-name": "Caminho 2430",
    d: "M1454.24,1226.778c0-27.552,17.783-49.438,45.335-49.438,27.942,0,45.527,21.886,45.527,49.438s-17.6,49.63-45.527,49.63C1472.023,1276.408,1454.24,1254.33,1454.24,1226.778Zm79.921,0c0-20.9-12.31-40.252-34.587-40.252-21.886,0-34.389,19.345-34.389,40.252,0,21.1,12.5,40.45,34.389,40.45C1521.851,1267.228,1534.161,1247.883,1534.161,1226.778Z",
    transform: "translate(-819.67 -1143.749)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2431",
    "data-name": "Caminho 2431",
    d: "M913.266,741.568q-2.167,3.784-4.631,7.321c-.088.115-.165.225-.242.341a100.165,100.165,0,1,1-3.839-119.976l-29.521,16.963a66.94,66.94,0,1,0,9.186,78.689L858.746,710.4a37.645,37.645,0,1,1-.242-37.623l7.349,12.514,79.833-45.863-7.437-12.739a129.987,129.987,0,0,0-111.9-64.355c-71.379,0-129.458,58.079-129.458,129.458s58.079,129.458,129.458,129.458a129.707,129.707,0,0,0,82.045-29.372v28.795h29.312V755.61l-11.7-6.721Z",
    transform: "translate(-663.371 160)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.42859cdf0462f728d6003cfe1c4393ba.svg";
export { ForwardRef as ReactComponent };